import styled from "styled-components";

export const StyledLayout = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.outerSpace};
`;

export const GlobalContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.redesign.white};
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 1560px;
  margin: 0 auto;
`;
